import React from 'react';
import {useTranslation} from "react-i18next";
import {DataPorter} from "../logic/db/porting/DataPorter";
import {RecipeDataHandler} from "../logic/db/RecipeDataHandler";
import Navbar from "../reusable/Navigations/Navbar";
import NavBarItemLink from "../reusable/Navigations/NavBarItemLink";
import NavBarItemDropDown from "../reusable/Navigations/NavBarItemDropDown";
import DropDownMenu from "../reusable/Information/DropDown/DropDownMenu";
import DropDownWindow from "../reusable/Information/DropDown/DropDownWindow";
import DropDownItem from "../reusable/Information/DropDown/DropDownItem";
import {Svgs} from '../assets/svgs/Svgs';

function Header() {
    const {t, i18n} = useTranslation('common')
    const {t: tBaking} = useTranslation('baking')

    const exportData = () => {
        DataPorter.export().catch(() => console.log("Data could not be exported!"))
    }

    return (
        <header>
            <h1 className="title">{t('title')}</h1>
            <Navbar>
                <NavBarItemLink to={"/ingredients"} text={tBaking("ingredient_other")}/>
                <NavBarItemLink to={"/recipes"} text={tBaking('recipe_other')}/>
                <NavBarItemDropDown text={t('language.language')} icon={<Svgs.FlagSvg flag={i18n.language === 'de' ? 'austria' : 'usa'}/>}>
                    <DropDownMenu initWindow={"language"}>
                        <DropDownWindow windowName={"language"} transitionClassName={"language"}>
                            <DropDownItem onMouseUp={() => i18n.changeLanguage('de')}>
                                <Svgs.FlagSvg flag={'austria'}/>
                                <div>{t("language.german")}</div>
                            </DropDownItem>
                            <DropDownItem onMouseUp={() => i18n.changeLanguage('en')}>
                                <Svgs.FlagSvg flag={'usa'}/>
                                <div>{t('language.english')}</div>
                            </DropDownItem>
                        </DropDownWindow>
                    </DropDownMenu>
                </NavBarItemDropDown>
                <NavBarItemDropDown text={t("portability.portability")}>
                    <DropDownMenu initWindow={"portability"}>
                        <DropDownWindow windowName={"portability"} transitionClassName={"portability"}>
                            <DropDownItem onMouseUp={() => exportData()}>
                                <Svgs.DownLoadSvg/>
                                <div>{t("portability.export")}</div>
                            </DropDownItem>
                            <DropDownItem>
                                <FileInput/>
                            </DropDownItem>
                        </DropDownWindow>
                    </DropDownMenu>
                </NavBarItemDropDown>
            </Navbar>
        </header>
    );
}

function FileInput() {
    const importData = (e: any) => {
        const files: FileList = e.target.files
        if (files.length === 1 && files.item(0) !== null) {
            const item = files.item(0)
            if (item !== null) {
                DataPorter.importFile(item).then(data => {
                    const rewriteData = [
                        {data: (data as any).ingredients, storeName: 'ingredients'},
                        {data: (data as any).recipes, storeName: 'recipes'},
                    ]
                    return RecipeDataHandler.rewriteAll({schemas: rewriteData})
                }).catch(() => console.log("Error importing data!"))
            }
        }
    }

    const {t} = useTranslation('common')

    return (
        <label>
            <input type="file" onChange={(e: any) => importData(e)} hidden={true}/>
            <Svgs.UploadSvg/>
            {t("portability.import")}
        </label>
    )
}

export default Header;
